import { Layout } from 'antd';
import { useScreenBreakpoint } from 'hooks';
import { isMobileDevice } from 'utils/device';
import BottomBar from './components/BottomBar';

type FooterProps = {
  collapsed: boolean,
  handleChange: (force?: boolean) => void,
}

const Footer = ({ collapsed, handleChange }: FooterProps) => {
  const { isMobile } = useScreenBreakpoint();

  // Tablets and unfolded foldables have desktop-sized viewports but still scan with a camera.
  if (isMobile || isMobileDevice()) return <BottomBar collapsed={collapsed} handleMenuClick={handleChange} />;

  return <Layout.Footer className={`layout-footer${collapsed ? '-collapsed' : ''}`}>Running on {process.env.REACT_APP_ENVIRONMENT}</Layout.Footer>;
};

export default Footer;